import { Css, ScrollableParent } from "@homebound/beam";
import { Outlet } from "react-router-dom";

/**
 * Gray scroll frame for legacy library-style pages still on `GlobalNavLayout`.
 *
 * Role: data router pathless layout — **legacy only**. Do not use for new migrations.
 *
 * New migrated pages that use Beam layouts (`PageHeaderLayout`, `GridTableLayout`, etc.) should
 * nest under `BeamNavbarLayout` only — see `domains/projects.ts` and the index route in
 * `domains/libraries.ts`. See `src/routing/README.md` "Layout stacks".
 */
export function ScrollableParentLayout() {
  return (
    <ScrollableParent px={3} xss={Css.fg1.bgGray100.$}>
      <Outlet />
    </ScrollableParent>
  );
}
